import { returnAction } from "../helpers/helpers";
import {
  EDITING_USER,
  SAVE_USER_REQUEST,
  LOAD_USERS,
  LOAD_USERS_FAIL,
  LOAD_USERS_SUCCESS,
  ADDING_USER,
  END_ACTION,
  ADD_USER_REQUEST,
  TOGGLE_DEACTIVATE,
  TOGGLE_DEACTIVATE_FAIL,
  TOGGLE_DEACTIVATE_SUCCESS,
  VIEWING_USER,
  EDITING_USER_FORM,
} from "./actionTypes";

export const startEditUser = () => ({
  type: EDITING_USER,
});

export function saveUserRequest() {
  return {
    type: SAVE_USER_REQUEST,
  };
}

export const loadUsers = (user) => ({
  types: [LOAD_USERS, LOAD_USERS_SUCCESS, LOAD_USERS_FAIL],
  promise: (client) =>
    client.get("/users", {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      params: {
        role: user.role,
        groups: user.groups,
        project: user.project,
        site: user.site,
        responsibility_group: user.responsibility_group,
        rolesRestriction: user.rolesRestriction,
      },
    }),
});

export const startAddUser = () => returnAction(ADDING_USER);
export const handleClose = () => returnAction(END_ACTION);
export const addUserRequest = () => returnAction(ADD_USER_REQUEST);
export const handleSubmit = (func) => func();

export const handleToggleDeactivate = (user, userId, username, status) => {
  const action = status === "deleted" ? "reactivate" : "deactivate";

  return {
    types: [
      TOGGLE_DEACTIVATE,
      TOGGLE_DEACTIVATE_SUCCESS,
      TOGGLE_DEACTIVATE_FAIL,
    ],
    promise: (client) =>
      client.post(`/user/${action}/${userId}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          username,
        },
      }),
  };
};

export const startViewUser = (row) => ({
  type: VIEWING_USER,
  row,
});

export const handleChange = (e, inputId = null) => {
  let inputValue = "";

  if (!inputId) {
    // eslint-disable-next-line
    inputId = e.target.id;
    if (e.target.type === "checkbox") {
      inputValue = e.target.checked;
    } else {
      inputValue = e.target.value;
    }
  } else {
    inputValue = e;
  }

  return {
    type: EDITING_USER_FORM,
    input_id: inputId,
    input_value: inputValue,
  };
};
